module.exports = __webpack_public_path__ + "static/img/file_excle.733b7093.png";